var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "trims-accessories-result" },
    [
      _vm._l(_vm.trimsAndAccessories, function(item, index) {
        return _c("div", { key: index, staticClass: "result" }, [
          _c("div", [
            _c("img", {
              attrs: {
                src: item.trimColors[0].imagesInfo[0].url,
                alt: "Main Image"
              }
            }),
            _vm._v(" "),
            _c("div", {
              staticClass: "wf-swiper-thumbnails",
              class: "wf-product-thumbnails-size-" + "sizehere"
            }),
            _vm._v(" "),
            _c("div", { staticClass: "description" }, [
              _c("div", [
                _vm._v(
                  _vm._s(item.sellingStyleName + " " + item.sellingStyleNumber)
                )
              ]),
              _vm._v(" "),
              _c("div", [
                _vm._v(
                  _vm._s(
                    item.trimColors.length +
                      " " +
                      (item.trimColors.length > 1 ? "colors" : "color")
                  )
                )
              ]),
              _vm._v(" "),
              _c("div", [
                _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        return _vm.learnMore(item)
                      }
                    }
                  },
                  [_vm._v("Learn More")]
                )
              ]),
              _vm._v(" "),
              _c("div", [
                _vm._v(" For more samples or more information "),
                _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        return _vm.contactManager(item)
                      }
                    }
                  },
                  [
                    _vm._v(
                      " contact your Patcraft account\n            manager"
                    )
                  ]
                )
              ])
            ])
          ])
        ])
      }),
      _vm._v(" "),
      _vm.trimsAndAccessories.length === 0 && !_vm.isFetching
        ? _c("p", [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$resourceString["common.noResults"]) +
                "\n  "
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._m(0)
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass:
          "wf-swiper-nav-button wf-swiper-nav-button-next btn btn-full",
        attrs: { type: "button" }
      },
      [
        _c("span", {
          staticClass:
            "\n            png-icon\n            png-icon-icons-glyph--ko-chevron-right\n            arrow-right\n            png-size\n            mt-1\n          ",
          attrs: { "aria-label": "Next color" }
        })
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }